<template>
  <img src="~/assets/icon/icon-maestro.svg" />
</template>
